import React, { Component } from 'react';

import url from 'url';
import get from 'lodash.get';
import uuidv4 from 'uuid/v4';
import { Embed } from 'semantic-ui-react';

import TwitchVideo from './twitchVideo';

class Video extends Component {

	determineType() {
		if (this.props.value) {
			/* eslint-disable-next-line*/
			if (this.props.value.match("http(?:s?):\\\/\\\/(?:www\\.)?youtu(?:be\\.com\\\/watch\\?v=|\\.be\\\/)([\\w\\-\\_]*)(&(amp;)?\u200C\u200B[\\w\\?\u200C\u200B=]*)?") !== null) {
				return {
					type: 'youtube',
					code: (this.props.value.indexOf('watch') !== -1)
						? get(url.parse(this.props.value, true), 'query.v')
						: url.parse(this.props.value).path.substr(1)
				};
			}

			/* eslint-disable-next-line*/
			var vimeoResult = this.props.value.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i);
			if (vimeoResult) {
				return {
					type: 'vimeo',
					code: url.parse(this.props.value).path.substr(1)
				};
			}

			/* eslint-disable-next-line*/
			var twitchResult = this.props.value.match(/^(?:(https?):\/\/)?(?:www\.)?twitch\.tv\/videos\/(\d+)/i);
			if (twitchResult) {
				return {
					type: 'twitch',
					code: url.parse(this.props.value).path.substr(1).split(/\//)[1],
					targetID: uuidv4()
				}
			}
		}
		return null;
	}

	render() {
		const videoConfig = this.determineType();

		if (!videoConfig) {
			return null;
		}

		return (
			<React.Fragment>
				{
					videoConfig &&
					(videoConfig.type === 'youtube' || videoConfig.type === "vimeo") &&
					<Embed id={videoConfig.code.replace(/video\//, '')}
						source={videoConfig.type}
						active
						autoplay={false} />
				}
				{
					videoConfig && videoConfig.type === 'twitch' &&
					<TwitchVideo
						width="100%"
						height={350}
						targetID={videoConfig.targetID}
						video={videoConfig.code}
						autoplay={false} />
				}
			</React.Fragment>
		);
	}
}

export default Video;
